function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "9",
  viewBox: "-6 -3 32 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.484 4.063V2.516h-7.84v1.546zm-3.129 6.292V8.773h-4.71v1.582zm3.13-3.128V5.645h-7.84v1.582zM14.292.16c.418 0 .781.152 1.086.461.309.309.46.668.46 1.086v9.422c0 .418-.152.785-.46 1.105-.309.317-.668.477-1.086.477H4.871c-.418 0-.785-.16-1.101-.477-.32-.32-.48-.687-.48-1.105V1.707c0-.418.16-.777.48-1.086.316-.308.683-.46 1.101-.46zM1.707 3.29v11.003h11.004v1.547H1.707c-.418 0-.781-.152-1.086-.461a1.48 1.48 0 01-.46-1.086V3.289zm0 0"
})));